import { ChevronLeft, ChevronRight, ChevronDown, ChevronsUp, DoorOpen, PenLine } from "lucide-react";
import { useT } from "../i18n";

const Btn = ({ k, input, label, testId, children, big }) => {
  const set = (down) => (e) => {
    e.preventDefault();
    if (down) e.currentTarget.setPointerCapture?.(e.pointerId);
    e.currentTarget.classList.toggle("pressed", down);
    input.current?.(k, down);
  };
  return (
    <button
      className={`touch-btn ${big ? "touch-btn-big" : ""}`}
      aria-label={label}
      data-testid={testId}
      onPointerDown={set(true)}
      onPointerUp={set(false)}
      onPointerCancel={set(false)}
      onLostPointerCapture={set(false)}
      onContextMenu={(e) => e.preventDefault()}
    >
      {children}
    </button>
  );
};

export const TouchPad = ({ side, input }) => {
  const t = useT().touch;
  return side === "left" ? (
    <div className="touch-pad touch-pad-left" data-testid="touch-pad-left">
      <Btn k="left" input={input} label={t.left} testId="touch-left-button" big><ChevronLeft size={30} /></Btn>
      <Btn k="right" input={input} label={t.right} testId="touch-right-button" big><ChevronRight size={30} /></Btn>
      <Btn k="down" input={input} label={t.down} testId="touch-down-button"><ChevronDown size={22} /></Btn>
    </div>
  ) : (
    <div className="touch-pad touch-pad-right" data-testid="touch-pad-right">
      <Btn k="mark" input={input} label={t.chalk} testId="touch-chalk-button"><PenLine size={20} /><span>{t.chalk}</span></Btn>
      <Btn k="up" input={input} label={t.enter} testId="touch-enter-button"><DoorOpen size={22} /><span>{t.enter}</span></Btn>
      <Btn k="jump" input={input} label={t.jump} testId="touch-jump-button" big><ChevronsUp size={30} /><span>{t.jump}</span></Btn>
    </div>
  );
};

export const isTouchDevice = () =>
  new URLSearchParams(window.location.search).has("touch") ||
  window.matchMedia("(pointer: coarse)").matches ||
  "ontouchstart" in window;
